module.exports = __webpack_public_path__ + "img/b-logolarge.df6fc627.png";